module.exports = __webpack_public_path__ + "static/media/zip.0976c52d.svg";